import { Icon } from "@smartsuite/react-ui/lib";
import { GrayColors } from "@smartsuite/types";
import React, { type FunctionComponent } from "react";

import "./TableAddRow.sass";

interface TableAddRowProps {
  title: string;
  onClick?: () => void;
}

export const TableAddRow: FunctionComponent<TableAddRowProps> = ({ title, onClick }) => {
  return (
    <button
      aria-label="Table add row button"
      type="button"
      className="table-add-row"
      onClick={onClick}
      data-testid="linked-record-link-button"
    >
      <Icon name="plus-thin-small" size="S" color={GrayColors["G-8"]} />
      {title}
    </button>
  );
};
